import React from 'react';
import {useParams} from 'react-router-dom';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {BulkSyncModal} from './bulk-sync.modal';

import type {CrmSyncType} from 'src/openapi/admin/models/CrmSyncType';

type Props = {
    disabled?: boolean,
    crmType: CrmSyncType,
};

export const BulkSync = ({crmType, disabled}: Props) => {
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : 1;

    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <Button variant="Type.SECONDARY" disabled={disabled} onClick={onClick}>
                Bulk Sync
            </Button>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <BulkSyncModal
                    accountId={accountId}
                    crmType={crmType}
                    onClose={onClose}
                />
            </Dialog>
        </>
    );
};
